<template lang="html">
<div>
		<vx-card class="mb-1">
			<div class="vx-row mb-2">
				<div class="vx-col mb-2">
					<h3>
						Filtres :
					</h3>
				</div>
					<!-- CLIENT -->
					<div class="vx-col px-1 mb-2">
					<vs-input class="inputx" placeholder="Client" v-model="clientFilter" @input="ordersFilter(allOrders)"/>
				</div>
				<!-- CLIENT -->
				<!-- CONTRACT -->
				<div class="vx-col px-1 mb-2">
					<vs-input class="inputx" placeholder="N° de Contrat" v-model="contractIdFilter" @input="ordersFilter(allOrders)"/>
				</div>
				<!-- CONTRACT -->
				<!-- Order product Filter -->
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderProductFilter"
						class="w-full select-large"
						placeholder="Prestations"
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Prestations"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.displayName"
							v-for="(item, index) in productOptions"
							class="w-full"
						/>
					</vs-select>

				</div>
				<!-- Brief Filter -->
				<!-- <div class="vx-col px-1 mb-2">
					<vs-input class="inputx" placeholder="Brief" v-model="briefFilter" @input="ordersFilter(allOrders)"/>
				</div> -->

				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderStatusFilter"
						class="w-full select-large"
						placeholder="Statut (Sélection multiple)"
						multiple
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in orderStatusOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<!-- Billable Filter -->
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderBillableFilter"
						class="w-full select-large"
						placeholder="Facturable"
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Facturation"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.value+1"
							:text="item.text"
							v-for="(item, index) in billableOptions"
							class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
					<vs-select
						v-model="orderConsultantFilter"
						class="w-full select-large"
						placeholder="Consultant Rankwell"
						autocomplete
						@change="ordersFilter(allOrders)"
					>
						<vs-select-item
							value=""
							text="Consultants"
							class="w-full"
						/>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.firstname +' '+ item.lastname"
							v-for="(item, index) in getAllConsultants()"
							class="w-full"
						/>
					</vs-select>

				</div>
			</div>
			<div class="vx-row w-full mt-2">
				<div class="vx-col">
					<strong>Nombre de commandes : {{ cloneListOrders.length }}</strong>
				</div>
			</div>
		</vx-card>
<CommandeTable :orders="cloneListOrders" :contract="contract" :readOnly="false" :fromProjectMang="true" :fromAllOrders="true"  ref="orderTable" style="margin-left:-10px; width: calc(100% + 20px);" :key = "refreshOrderTable"/>
		</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VueCookies from "vue-cookies";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import CommandeTable from "@/components/tables/CommandeTable";
export default {
	created() {
		store.dispatch("getAllProducts");
		store.dispatch("getAllCollaborators");
		this.getAllProductsCategories();
		this.fetchAllOrders();
		//getting orders which belongs to user sign in
	},
	components: {
		CommandeTable,
	},
	mounted() {},
	name: "AllOrderPopup",
	mixins: [dbFieldConvertor],
	props: {
		society: Object,
		popupActive: Boolean,
		brands: Array,
	},

	data() {
		return {
			allOrders: [],
			propShowBrandEditor: false,
			apiUrl: this.$store.state.backendApiUrl,
			orderProductFilter: "",
			briefFilter: "",
			// brands: null,
			orderStatusFilter: [1, 2],
			orderBillableFilter: "",
			orderConsultantFilter: "",
			clientFilter: "",
			contractIdFilter: "",
			mergedKeywords: [],
			consultantList: [],
			productOptions: [],
			products_categories: [],
			cloneListOrders: [],
			orderStatusOptions: [
				{ text: "À faire", value: 1 },
				// {text: "En cours", value: 2},
				{ text: "Fait", value: 2 },
				{ text: "Terminée", value: 4 },
				{ text: "Annulé", value: 3 },
			],
			billableOptions: [
				{ text: "Facturable", value: 1 },
				{ text: "Non-facturable", value: 0 },
			],
			contract: {
				contract_id: "",
				society_id: "",
			},
			refreshOrderTable: 0,
		};
	},
	computed: {
		allCollaborators: () => {
			return store.state.collaborators;
		},
		products: () => {
			return store.state.products;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		filteredList: () => {
			return this.allOrders;
		},
	},
	methods: {
		/**
		 * Fetch all orders
		 */
		fetchAllOrders() {
			this.$http
				.get(this.apiUrl + "orders/all")
				.then(async (res) => {
					this.allOrders = res.data;
					this.cloneListOrders = this.allOrders;
				})
				.catch((err) => {
					throw err;
				});

			this.getAllProductForCategory();
		},
		getAllConsultants() {
			console.log("getAllConsultants", this.allCollaborators);
			return this.allCollaborators.filter((collaborator) =>
				[3, 6, 7, 9].includes(collaborator.type)
			);
		},
		/**
		 * getAllProductsCategories - getting all categories products
		 */
		getAllProductsCategories() {
			this.$http
				.get(this.apiUrl + "product/category/all")
				.then((res) => {
					// //console.log("getAllProductsCategories", res.data);
					this.products_categories = res.data.map((row) => row.name);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		/**
		 * getProductPrestation - filter product with its id
		 * @params {Number} productId
		 */
		getProductPrestation(productId) {
			let foundProduct = this.products.find(
				(product) => product.id == productId
			);
			return foundProduct.perform;
		},
		/**
		 * getAllProducts - getAll products and sotre in a store
		 */
		getAllProducts() {
			store.dispatch("getAllProducts");
		},
		/**
		 * ordersFilter - execute in every change of filter
		 * @params {Object} orders - allorders to be filtered
		 * @return {void}
		 */
		ordersFilter(orders) {
			let tmpList = JSON.parse(JSON.stringify(orders));
			if (this.clientFilter != null)
				tmpList = tmpList.filter(
					(o) =>
						o.name.toLowerCase().indexOf(this.clientFilter.toLowerCase()) > -1
				);
			if (this.contractIdFilter != null)
				tmpList = tmpList.filter((o) =>
					o.contract_id.toString().includes(this.contractIdFilter.toString())
				);
			// if(this.briefFilter != null) tmpList = tmpList.filter(o => o.brief_text.toLowerCase().indexOf(this.briefFilter.toLowerCase()) > -1);
			/*
			 * if(this.orderAccountmanagerFilter > 0) tmpList = tmpList.filter(o => o.account_manager_id == this.orderAccountmanagerFilter);
			 *
			 */
			//filter order with its product type
			if (this.orderProductFilter > 0)
				tmpList = tmpList.filter(
					(o) => o.product_id.toString() == this.orderProductFilter
				);
			//filter order with its status
			if (this.orderStatusFilter.length > 0)
				tmpList = tmpList.filter(
					(o) => this.orderStatusFilter.indexOf(o.status) > -1
				);
			//filter order with billable
			if (this.orderBillableFilter && this.orderBillableFilter > -1)
				tmpList = tmpList.filter(
					(o) => parseInt(this.orderBillableFilter) - 1 == o.billable
				);
			if (this.orderConsultantFilter > 0)
				tmpList = tmpList.filter(
					(o) => parseInt(this.orderConsultantFilter) == o.account_manager_id
				);
			//Parsing into json string
			this.listOrders = JSON.parse(JSON.stringify(orders));
			this.cloneListOrders = JSON.parse(JSON.stringify(tmpList));
			this.refreshOrderTable++;
		},

		/**
		 * Query our API to fetch all product for a category
		 */
		getAllProductForCategory() {
			this.$http
				.get(this.apiUrl + "product/all/1")
				.then((res) => {
					let cat = res.data[0].category;
					this.productOp = res.data.filter(
						(p) => p.category == cat || p.category == 7 || p.category == 8
					);
					this.productOp.forEach((ele) => {
						this.productOptions.push({
							...ele,
							displayName: ele.category_name + " - " + ele.perform,
						});
						this.productOptions.sort(function (a, b) {
							if (a.displayName < b.displayName) {
								return -1;
							}
							if (a.displayName > b.displayName) {
								return 1;
							}
							return 0;
						});
					});
				})
				.catch((err) => {
					//console.log("AllOrderPopup , getAllProductForCategory Err: ", err);
				});
		},
	},
	watch: {
		contract: {
			deep: true,
			handler(data) {
				try {
					this.allOrders = [];
					this.allMissions = [];
					Mission.getMissionsForContract(data.id, (err, res) => {
						this.allMissions = res.data;
						for (let i = 0; i < this.allMissions.length; i++) {
							this.allMissions[i]["products_number"] = i + 1;
						}
						this.filteredMissions =
							this.missionFilter == 1 && ![4, 5].includes(this.contract.status)
								? res.filter((m) => ![4, 5].includes(m.status))
								: [...this.allMissions];
					});
					this.getAllOrdersForContract();
				} catch (err) {
					//console.log("AllOrderPopup , contract Err: ", err);
				}
			},
		},

		allOrders: {
			deep: true,
			handler(data) {
				this.ordersFilter(data);
			},
		},
	},
};
</script>
